module.exports = __webpack_public_path__ + "static/media/Dikaiwsi_14.acace3fa.jpg";